import { useCallback, useState } from 'react'
import * as Api from 'apps/fleet-planner/utils/api'
import { IActivity } from '../types/activity'

interface IUseActivityApiState {
  error?: string
  activityList: IActivity[]
  isLoading: boolean
  getActivities: (loadId?: string) => void
}

export const useActivityApi = (): IUseActivityApiState => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [activityList, setActivityList] = useState<IActivity[]>([])
  const [error, setError] = useState<string>('')

  /**
   * Fetch activity data + return the activites list
   */
  const getActivities = useCallback(async (loadId?: string) => {
    if (!loadId) return undefined
    setError('')
    setLoading(true)
    try {
      const response = await Api.fetchActivityList(loadId)
      const { activities } = response
      setActivityList(activities)
      setLoading(false)
      return response
    } catch (e) {
      setError(e)
      setLoading(false)
      return undefined
    }
  }, [])

  return {
    error,
    getActivities,
    activityList,
    isLoading,
  }
}
